import PositioningDeviceFittingsTypePictureModal from './positioning-device-fittings-type-picture-modal.vue'
export default PositioningDeviceFittingsTypePictureModal
